import _class from "./class.js";
import _assignment from "./assignment.js";
import _account from "./account.js";
import _exercise from "./exercise.js";
import _blogs from "./blogs.js";
import _form from "./form.js";
import _subscription from "./subscription.js";
import _schools from "./schools.js";
import _notifications from "./notifications.js";
import _tabuleoSubscription from "./tabuleoSubscription.js";
import _garSubscription from "./garSubscription.js";
import _students from "./students.js";
import _country from "./country.js";
import _teachers from "./teachers.js";
import _payment from "./payment.js";
import _resource from "./resource.js";
import _purge from "./purge.js";
import _mockExams from "./mockExams.js";
import _twoFactorAuth from "./twoFactorAuth.js";
import _session from "./session.js";
import _maintenance from "./maintenance.js";

const message = {
  languages: {
    language: "Language",
    french: "French",
    english: "English",
    german: "German",
  },
  notes: {
    helpNotePart1:
      "Note: This exercise has a help mode that you can activate by clicking the button",
    helpNotePart2:
      "next to each question. Warning: If you use the help mode, you can earn a maximum of half the points for the question.",
  },
  bugCategories: {
    51: "Exercises",
    52: "Assignments",
    53: "Personal account",
  },
  admin: "Administrator",
  chapter: "Chapter",
  subchapter: "Subchapter",
  talkingAboutUs: "In the media",
  back: "Back",
  backToContents: "Back to contents",
  trainAgain: "Practice again",
  title: "Title",
  link: "Link",
  text: "Text",
  filterBy: "Filter by :",
  access: "Access",
  homeworkList: "Assignments",
  picture: "Picture",
  keywords: "Keywords",
  firstname: "First Name",
  lastname: "Last Name",
  email: "Email Address",
  publishDate: "Publication date",
  modificationDate: "Last modified",
  commercialConsent: "Marketing consent",
  lastLogin: "Last login",
  accepted: "Accepted",
  notAccepted: "Declined",
  phone: "Phone",
  password: "Password",
  oldPassword: "Current password",
  newPassword: "New password",
  forgotPassword: "Forgot your password?",
  confirmPassword: "Confirm password",
  all: "All",
  pswdHelp:
    "The password must be at least 8 characters long and include at least one special character.",
  receivingCommercial:
    "By checking this box, I agree to receive marketing communications from iizenglish.",
  termsAccepted: "I agree to",
  termsAndConditions: "the Terms and Conditions.",
  termsAndConditionsAcceptedHelp: "You must accept the Terms and Conditions.",
  registrationTitle: "Sign up for iizenglish",
  restPasswordTitle: "Reset your password!",
  resetPasswordRequested:
    "Your password reset request has been processed (the email may take up to one minute to arrive. Please check your spam folder).",
  submit: "Confirm",
  loading: "Loading",
  thanksJoining: "Thank you for joining iizenglish!",
  welcomeAdminHome: "Welcome to the Admin Dashboard",
  mailSent: "An email has been sent to you",
  newMailSent: "A new email has been sent to you.",
  validationExpired:
    "This verification link has expired. Please enter your email address again:",
  requestExpired: "Your request has expired.",
  signup: "Create an account",
  login: "Log in",
  logout: "Log out",
  success: "Success",
  error: "Error",
  warning: "Notice",
  mandatoryField: "This field is required.",
  mandatoryIntegerField: "This field is required and must be an integer.",
  maxLengthField: "This field must not exceed {maxLength} characters.",
  dynamicMandatoryField: "The {field} field is required.",
  dynamicErrorField: "The {field} field is invalid.",
  passwordTitle: "Create your password",
  newPasswordTitle: "Enter your new password",
  mandatoryFieldWithFormat:
    "This field is required and must be in the correct format.",
  parameters: "Settings",
  search: "Search",
  tableOfContents: "Contents",
  train: "Practice",
  assign: "Assign",
  enterKeyword: "Type your keywords here…",
  example: "Example",
  audioNotSupported: "Your browser cannot play audio files.",
  cancel: "Cancel",
  confirmDelete: "Yes, delete",
  confirm: "Yes, I confim",
  close: "Close",
  sendUserReminder: "Send a reminder",
  saveModification: "Save changes",
  reportBug: "Report a bug",
  screenshot: "Screenshot",
  thatIs: "until",
  noResult: "No results found",
  connectingPleaseWait: "Logging in, please wait",
  none: "None",
  passwordsDontMatch: "Passwords don't match.",
  validate: "Submit",
  userPersonalData: "Personal data",
  comment: "Comment",
  level: "Level | Levels",
  levelUnquantified: "Level(s)",
  optional: "optional",
  nonStudentAccountAlreadyExists:
    "A teacher account already exists for this email address.",
  accountAlreadyExistsBadParams:
    "Please make sure you have the correct student details; this email address is already used for another student.",
  duplicateEmail: "This email address is used multiple times.",
  activationStatus: "Statut",
  startDate: "Start date",
  endDate: "Due date",
  creationDate: "Created on",
  missingStudentsLevel:
    "Some students have no level assigned and won’t be able to access this assignment.",
  numberShort: "No.",
  previous: "Previous",
  next: "Next",
  finish: "Submit",
  nextStep: "Next",
  previousStep: "Previous",
  yourSelection: "Your selection",
  menuBack: "Back to menu",
  summary: "Contents",
  dynamicModel: "Template {modelNumber}",
  instruction: "Instructions",
  instructionImage: "Click on an image to enlarge it.",
  markScale: "Grading scale",
  proposition: "Option | Options",
  question: "Question | Questions",
  answer: "Answer | Answers",
  part: "Part | Parts",
  addQuestion: "Add question",
  addPart: "Add part",
  helpersActivated:
    "Help was used for {X} out of {Y} correct answers. Each answer where help was used is worth half the points.",
  help: "Help",
  helpEnabled: "used. This question is worth half the points.",
  preview: "Preview",
  reset: "Reset",
  category: "Category",
  chooseCategory: "Select a category",
  grammar: "Grammar",
  vocabulary: "Vocabulary",
  chooseChapter: "Select a chapter",
  chooseSubchapter: "Select a subchapter",
  position: "Order",
  yes: "Yes",
  no: "No",
  publishedQuestion: "Publish?",
  publish: "Publish",
  demoAvailableQuestion: "Available as a demo?",
  save: "Save",
  update: "Edit",
  extract: "Extract",
  published: "Published",
  saveAndPublish: "Save and publish",
  notPublished: "Unpublished",
  personalInformation: "Profile",
  pleaseEnter: "Please type to confirm",
  remainingTime: "Time remaining",
  dayShort: "d",
  individual: "Individual",
  chapters: "Chapters",
  resetTableOfContent: "Reset contents",
  status: "Status",
  activated: "Active",
  notActivated: "Inactive",
  detail: "Details",
  delete: "Delete",
  message: "Message",
  send: "Send",
  city: "City",
  zip: "Zip code",
  address: "Address",
  name: "Name",
  toManyRequests:
    "You’ve sent too many messages today. Please try again later.",
  messageSent: "Message sent.",
  dataContactMessage:
    "The data collected through this form is processed by IIZENGLISH to handle your contact request.",
  dataSubscriptionMessage:
    "The data collected through this form is processed by IIZENGLISH to manage your registration on the website.",
  privacyPolicyMessage:
    "Learn more about how we handle your data and your rights.",
  organization: "School",
  filters: "Filters",
  downloadInPdf: "Download as PDF",
  view: "Preview",
  actions: "Actions",
  newContentAvailable: "Update available.",
  pleaseRefresh: "Update",
  validationEmailSended:
    "A new activation email has been sent. Use it to create your password.",
  checkSpam: "(Please check your spam folder.)",
  invitationNotAccepted:
    "You’ve been invited to join iizenglish, but you haven’t accepted the invitation yet.",
  setPasswordMailResent:
    "A new invitation email has been sent. It will take you to set your password and activate your account.",
  studentEmailNotDelivered: "Email not delivered",
  checkStudentEmail: "Please check the student’s email address.",
  definitiveAction: "This action cannot be undone.",
  irreversible: "This action cannot be undone.",
  areYouSure: "Are you sure you want to continue?",
  ALL: "ALL",
  verify: "Confirm",
  cookieBannerTitle: "Cookies on iizenglish",
  cookieBannerLegal:
    "By continuing to browse this site, you agree to the use of cookies strictly necessary for its proper functioning. If you would like to learn more, click this",
  cookieDetailLink: "link",
  ok: "OK",
  activate: "Activate",
  generate: "Generate",
  numberOfLines: "Number of rows:",
  file: "File:",
  type: "Type",
  understood: "Got it",
  scrollToViewMore: "Scroll horizontally to see more",
  gradingSystem: "Grading system",
  globalParameter: "Global settings",
  parameter: "Setting",
  description: "Description",
  value: "Value",
  class: _class,
  assignment: _assignment,
  account: _account,
  exercise: _exercise,
  blogs: _blogs,
  form: _form,
  subscription: _subscription,
  schools: _schools,
  notifications: _notifications,
  tabuleoSubscription: _tabuleoSubscription,
  garSubscription: _garSubscription,
  students: _students,
  country: _country,
  teachers: _teachers,
  payment: _payment,
  resource: _resource,
  purge: _purge,
  mockExams: _mockExams,
  twoFactorAuth: _twoFactorAuth,
  session: _session,
  maintenance: _maintenance,
};

export default message;
